export default __webpack_public_path__ + "static/media/classicvr3.b3f2c542.webp";